<template>
  <div class="aside__subblock">
    <div class="aside__list">
      <div class="aside__item">
        <SelectInTeam
          v-model="selectedLeader"
          :select-data="localTeam"
          title="Лидер"
          placeholder="Выбрать лидера..."
        ></SelectInTeam>
      </div>
      <div class="aside__item">
        <SelectInAll
          v-model="selectedCaptian"
          title="Капитан"
          :captain="captain"
          :array="localTeam"
          placeholder="Выбрать капитана..."
          @remove="removeCap"
        ></SelectInAll>
      </div>
      <div class="aside__item -full-">
        <Search
          v-model="search"
          :select-data="localTeam"
          :group-id="team.group.id"
          title="Остальные члены команды"
        ></Search>
      </div>
      <div class="aside__item -full-">
        <UsersList :data="localTeam" @remove="removeUser"></UsersList>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import Search from './Search';
import SelectInTeam from './Selects/SelectInTeam';
import SelectInAll from './Selects/SelectInAll';
import UsersList from './UsersList';

export default {
  components: { Search, SelectInTeam, SelectInAll, UsersList },
  data: () => ({
    teamBackup: [],
    localTeam: [],
    search: '',
    selectedLeader: '',
    selectedCaptian: '',
    checkboxLeader: false,
    checkboxCaptan: false,
    captain: '',
    removeCaptain: ''
  }),
  computed: {
    ...mapState('usersTeamMembers', {
      team: s => s.data.team,
      teammates: s => s.data.teammates,
      canSave: s => s.aside.meta.canSave,
      step: s => s.aside.meta.step
    }),
    leader() {
      return this.teammates.find(el => el.isLeader);
    }
  },
  watch: {
    search(val) {
      if (this.localTeam.length < 10) {
        if (this.localTeam.some(el => el.id === val.id)) {
          this.localTeam = this.localTeam.map(el => {
            if (el.id === val.id) {
              return val;
            }

            return el;
          });
        } else {
          this.localTeam.push(val);
        }
      }

      this.compare(true);
    },
    selectedCaptian(val) {
      if (val && val.id) {
        this.captain = this.createUser(val);
      }

      this.removeCaptain = undefined;
      this.compare(true);
    },
    selectedLeader(val) {
      this.localTeam = this.localTeam.map(el => {
        el.isLeader = false;

        if (val && val.id && el.id === val.id) {
          return val;
        }
        return el;
      });

      this.compare(true);
    }
  },
  beforeMount() {
    this.setData();
  },
  destroyed() {
    this.$store.dispatch('usersTeamMembers/setAsideData', {
      path: 'user',
      value: {}
    });
    this.$store.dispatch('usersTeamMembers/setAsideData', {
      path: 'team',
      value: []
    });
    this.$store.dispatch('usersTeamMembers/setAsideMeta', {
      path: 'canSave',
      value: false
    });
  },
  methods: {
    removeUser(item) {
      this.localTeam = this.localTeam.map(el => {
        if (el.id === item.id) {
          el.isDelete = true;
          el.isNew = false;
        }
        return el;
      });
      this.compare(true);
    },
    createUser(data) {
      return {
        isNew: false,
        id: data.id,
        avatar: data.avatar,
        email: data.email,
        name: data.name,
        lastname: data.lastname,
        isLeader: false,
        isCaptain: true,
        isDelete: false
      };
    },
    setData() {
      this.localTeam = _.cloneDeep(this.teammates).map(el => {
        return {
          isNew: false,
          name: el.name,
          email: el.email,
          lastname: el.lastname,
          id: el.id,
          avatar: el.avatar,
          isLeader: el.isLeader,
          isDelete: false,
          isCaptain: false
        };
      });

      if (this.team.captain) {
        this.captain = this.createUser(this.team.captain);
      }
    },
    compare(boolean) {
      let array = [];
      if (this.captain && this.captain.id) {
        array = [...this.localTeam, this.captain];
      } else if (this.removeCaptain && this.removeCaptain.id) {
        array = [this.removeCaptain, ...this.localTeam];
      } else {
        array = [...this.localTeam];
      }

      if (boolean) {
        this.$store.dispatch('usersTeamMembers/setAsideMeta', {
          path: 'canSave',
          value: true
        });
        this.$store.dispatch('usersTeamMembers/setAsideData', {
          path: 'team',
          value: array
        });
      } else {
        this.$store.dispatch('usersTeamMembers/setAsideMeta', {
          path: 'canSave',
          value: false
        });
        this.$store.dispatch('usersTeamMembers/setAsideData', {
          path: 'stagedUser',
          value: {}
        });
      }
    },
    nextStep() {
      this.$store.dispatch('usersTeamMembers/incrementStep');
      this.$store.dispatch('usersTeamMembers/setAsideData', {
        path: 'canSave',
        value: false
      });
    },
    removeCap(item) {
      this.captain = undefined;
      this.removeCaptain = { ...item, isCaptain: false };
      this.compare(true);
    }
  }
};
</script>
